import _ from 'lodash';

export const getStringArray = (stringOrStrings: string | string[]): string[] => {
  return _.isArray(stringOrStrings) ? stringOrStrings : [ stringOrStrings ];
};
